import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const FlexWrap = styled(Flex)`
  background: ${props =>
    props?.disabled ? COLORS.DISABLED_SECONDARY : COLORS.BLUE_T_95};
  border: 1px solid ${COLORS.BLUE_T_80};
  z-index: 1000;
  border-radius: 10px;
  gap: 20px;
  padding: 10px;
  margin-bottom: 20px;
  line-height: 20px;
  opacity: ${props => (props?.disabled ? 0.6 : 1)};
  transition: opacity 0.2s ease;
`
export const FlexWrapped = styled(Flex)`
  border: 1px solid ${COLORS.BLUE_T_80};
  z-index: 1000;
  border-radius: 10px;
  gap: 20px;
  padding: 10px;
  margin-bottom: 20px;
  line-height: 20px;
`
export const ActionWrap = styled(Flex)`
  gap: 5px;
  visibility: visible !important;
`
export const AnswerDiv = styled.div`
  color: #27ce86 !important;
  display: flex !important;
  align-items: center !important;
  font-weight: 400 !important;
`
export const MainFlex = styled(Flex)`
  position: relative;
`
export const ContentFlex = styled(Flex)`
  gap: ${props => (props.gap ? props.gap : '8px')};
  width: ${props => (props.width ? props.width : 'auto')};
  padding: ${props => (props.padding ? props.padding : '0 0 0 0 ')};
  white-space: normal;
  word-break: break-word;
  flex: 1;
`

export const Heading = styled.h1`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_P_100};
  margin-bottom: 0;
`
export const HeaderDiv = styled.h1`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
  margin-bottom: -10px;
`

export const Description = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_40};
`
export const ButtonDiv = styled(Flex)`
  cursor: pointer;
`

export const QuestionAnswerDiv = styled.div`
  cursor: pointer;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #343e59;
`
